<template>
    <div>
        <div id="spinner"></div>
    </div>
</template>
<script>
export default {
    name: 'theLoader',
}
</script>
<style lang="scss" scoped>
#spinner:not([hidden]) {
    position: fixed;
    z-index: 100;
    background-color: rgba(104, 101, 101, 0.4);
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background-image: url('../../assets/coaniquem-loading.png');
    background-position-x: center;
    background-position-y: center;
    background-size: 5%;
    background-repeat: no-repeat;
    @media screen and (max-width: 600px) {
        background-size: 15%;
    }
    @media screen and (min-width: 1300px) {
        background-size: 2%;
    }
}

#spinner::after {
    content: '';
    width: 100px;
    height: 100px;
    border: 2px solid #f3f3f3;
    border-top: 3px solid #f25a41;
    border-radius: 100%;
    will-change: transform;
    animation: spin 1s infinite linear;
}

@keyframes spin {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}
</style>
